export const SIGNUP_FORM_NAME = "SIGNUP_FORM";
